
declare global {
  var config: {
    REACT_APP_OKTA_CLIENT_ID: string;
    REACT_APP_OKTA_ISSUER: string;
    REACT_APP_OKTA_LOGOUT_URL: string;
    REACT_APP_SESSION_TIMEOUT_MINUTES: string;
    REACT_DYNATRACE_SCRIPT_URL: string;
    REACT_DYNATRACE_DATA_CONFIG: string;
  };
}

export const {
     REACT_APP_OKTA_CLIENT_ID,
     REACT_APP_OKTA_ISSUER,
     REACT_APP_OKTA_LOGOUT_URL,
     REACT_APP_SESSION_TIMEOUT_MINUTES,
     REACT_DYNATRACE_SCRIPT_URL,
     REACT_DYNATRACE_DATA_CONFIG
} = globalThis.config;
